import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as BroskIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/brosk.svg";
import { useConfig } from "../Config/useConfig";
export function ClickableBroskIcon() {
  var config = useConfig();
  var history = useHistory();

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      clickCounter = _useState2[0],
      setClickCounter = _useState2[1];

  var handleLogoClick = function handleLogoClick() {
    if (clickCounter === 9) {
      setClickCounter(0);
      history.push(config.serviceMenu);
    } else {
      setClickCounter(clickCounter + 1);
    }
  };

  useEffect(function () {
    if (clickCounter > 0) {
      var timeoutId = setTimeout(function () {
        setClickCounter(0);
      }, 1000);
      return function () {
        clearTimeout(timeoutId);
      };
    }
  }, [clickCounter, setClickCounter]);
  return /*#__PURE__*/React.createElement(BroskIcon, {
    onClick: handleLogoClick
  });
}